export const DEFAULT_ASSETS = [
  {
    id: 1882,
    uuid: "8d37115f-cea9-4907-9193-d65da1ecc340",
    title: "message.png",
    description: null,
    type: "image",
    asset_type: "my-media",
    path: "metaverse/objects/production/message-1730906210054.png",
    thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9xYS1kYXNoLm9ubGFuZC5pby9maWxlcy84ZDM3MTE1Zi1jZWE5LTQ5MDctOTE5My1kNjVkYTFlY2MzNDAucG5n?w=400&h=400",
    size: null,
    is_public: false,
    user_id: 12,
    is_360: true,
    url: "https://qa-dash.onland.io/files/8d37115f-cea9-4907-9193-d65da1ecc340.png",
    public_thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9xYS1kYXNoLm9ubGFuZC5pby9maWxlcy84ZDM3MTE1Zi1jZWE5LTQ5MDctOTE5My1kNjVkYTFlY2MzNDAucG5n?w=400&h=400",
    active: "not pivot",
    artwork: null,
    ar: null,
    shared: 0,
    owner: true,
    archived_at: null
  },
  {
    id: 1881,
    uuid: "3654869a-fb9f-4460-b7e4-cc251c967d86",
    title: "message.png",
    description: null,
    type: "image",
    asset_type: "my-media",
    path: "metaverse/objects/production/message-1730906205906.png",
    thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9xYS1kYXNoLm9ubGFuZC5pby9maWxlcy8zNjU0ODY5YS1mYjlmLTQ0NjAtYjdlNC1jYzI1MWM5NjdkODYucG5n?w=400&h=400",
    size: null,
    is_public: false,
    user_id: 12,
    is_360: true,
    url: "https://qa-dash.onland.io/files/3654869a-fb9f-4460-b7e4-cc251c967d86.png",
    public_thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9xYS1kYXNoLm9ubGFuZC5pby9maWxlcy8zNjU0ODY5YS1mYjlmLTQ0NjAtYjdlNC1jYzI1MWM5NjdkODYucG5n?w=400&h=400",
    active: "not pivot",
    artwork: null,
    ar: null,
    shared: 0,
    owner: true,
    archived_at: null
  },
  {
    id: 1843,
    uuid: "c37594bf-3773-4a37-a246-4c102bd42576",
    title: "5c9ed096-f5eb-48d5-ae3f-8d24c908adfc.mp4",
    description: null,
    type: "video",
    asset_type: "my-media",
    path: "assets360/QA_EventFy/my-media/production/5c9ed096-f5eb-48d5-ae3f-8d24c908adfc-5df49f1b-84b9-44e9-8107-713ff8f2c284.mp4",
    thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9uZXh0cmVhbGl0eWRpZ2l0YWwuYmxvYi5jb3JlLndpbmRvd3MubmV0L25leHRyZWFsaXR5ZGlnaXRhbC9hc3NldHMzNjAvUUFfRXZlbnRGeS9teS1tZWRpYS9wcm9kdWN0aW9uLzVjOWVkMDk2LWY1ZWItNDhkNS1hZTNmLThkMjRjOTA4YWRmYy10aHVtYi0yZGZmNTU5YS0wNDQ5LTQ4MmEtOTU1ZC02NGU0ODQ5OWNhMjIucG5n?w=400&h=400",
    size: null,
    is_public: false,
    user_id: 12,
    is_360: true,
    url: "https://qa-dash.onland.io/files/c37594bf-3773-4a37-a246-4c102bd42576.mp4",
    public_thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9uZXh0cmVhbGl0eWRpZ2l0YWwuYmxvYi5jb3JlLndpbmRvd3MubmV0L25leHRyZWFsaXR5ZGlnaXRhbC9hc3NldHMzNjAvUUFfRXZlbnRGeS9teS1tZWRpYS9wcm9kdWN0aW9uLzVjOWVkMDk2LWY1ZWItNDhkNS1hZTNmLThkMjRjOTA4YWRmYy10aHVtYi0yZGZmNTU5YS0wNDQ5LTQ4MmEtOTU1ZC02NGU0ODQ5OWNhMjIucG5n?w=400&h=400",
    active: "not pivot",
    artwork: null,
    ar: null,
    shared: 0,
    owner: true,
    archived_at: null
  },
  {
    id: 1838,
    uuid: "0937fef0-3bd5-4e9b-b658-127b887e17ee",
    title: "imagen_seo_tesouros_ancestrais_do_peru.jpg",
    description: null,
    type: "image",
    asset_type: "my-media",
    path: "assets360/qa_onland/my-media/production/imagen_seo_tesouros_ancestrais_do_peru-a4380a12-c2c8-4ab8-be3e-019b5d65173e.jpg",
    thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9xYS1kYXNoLm9ubGFuZC5pby9maWxlcy8wOTM3ZmVmMC0zYmQ1LTRlOWItYjY1OC0xMjdiODg3ZTE3ZWUuanBn?w=400&h=400",
    size: 154971,
    is_public: false,
    user_id: 12,
    is_360: false,
    url: "https://qa-dash.onland.io/files/0937fef0-3bd5-4e9b-b658-127b887e17ee.jpg",
    public_thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9xYS1kYXNoLm9ubGFuZC5pby9maWxlcy8wOTM3ZmVmMC0zYmQ1LTRlOWItYjY1OC0xMjdiODg3ZTE3ZWUuanBn?w=400&h=400",
    active: "not pivot",
    artwork: {
      id: 384,
      created_at: "2024-10-21T15:46:59.000000Z",
      updated_at: "2024-10-21T15:47:06.000000Z",
      title: "imagen_seo_tesouros_ancestrais_do_peru.jpg",
      artist: "Artist name",
      date: null,
      description: null,
      medium: null,
      technique: null,
      dimensions: null,
      artwork_model:
        "https://nextrealitydigital.blob.core.windows.net/nextrealitydigital/assets360/qa_onland/my-media/production/imagen_seo_tesouros_ancestrais_do_peru-bc02924c-f013-4227-9024-76e234dad86d-artwork-e0d26df3-55b4-46d0-9e72-aa0397e7d399.glb",
      dimensionsX: null,
      dimensionsY: null,
      dimensionsZ: null,
      unit: "in",
      artist_statement: null
    },
    ar: {
      id: 323,
      asset360_id: 1838,
      ar_code: "yw-O2QdVJ",
      qr_url: null
    },
    shared: 0,
    owner: true,
    archived_at: null
  },
  {
    id: 1837,
    uuid: "acae40c0-cd50-4b81-82c2-820e53b0396d",
    title: "Artwork",
    description: null,
    type: "image",
    asset_type: "my-media",
    path: "assets360/qa_onland/my-media/production/imagen_seo_tesouros_ancestrais_do_peru-ac37753c-4fef-4314-8b4c-75baebd302f3.jpg",
    thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9xYS1kYXNoLm9ubGFuZC5pby9maWxlcy9hY2FlNDBjMC1jZDUwLTRiODEtODJjMi04MjBlNTNiMDM5NmQuanBn?w=400&h=400",
    size: 154971,
    is_public: false,
    user_id: 12,
    is_360: false,
    url: "https://qa-dash.onland.io/files/acae40c0-cd50-4b81-82c2-820e53b0396d.jpg",
    public_thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9xYS1kYXNoLm9ubGFuZC5pby9maWxlcy9hY2FlNDBjMC1jZDUwLTRiODEtODJjMi04MjBlNTNiMDM5NmQuanBn?w=400&h=400",
    active: "not pivot",
    artwork: {
      id: 383,
      created_at: "2024-10-21T15:32:13.000000Z",
      updated_at: "2024-10-21T15:32:13.000000Z",
      title: "Artwork",
      artist: "Artist name",
      date: null,
      description: null,
      medium: null,
      technique: null,
      dimensions: null,
      artwork_model: null,
      dimensionsX: null,
      dimensionsY: null,
      dimensionsZ: null,
      unit: "in",
      artist_statement: null
    },
    ar: null,
    shared: 0,
    owner: true,
    archived_at: null
  },
  {
    id: 1828,
    uuid: "c5c705c2-0e0b-4162-ab06-28fdd9ab3eb4",
    title: "snap.png",
    description: null,
    type: "image",
    asset_type: "my-media",
    path: "metaverse/objects/production/snap-1728262334816.png",
    thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9xYS1kYXNoLm9ubGFuZC5pby9maWxlcy9jNWM3MDVjMi0wZTBiLTQxNjItYWIwNi0yOGZkZDlhYjNlYjQucG5n?w=400&h=400",
    size: null,
    is_public: false,
    user_id: 12,
    is_360: true,
    url: "https://qa-dash.onland.io/files/c5c705c2-0e0b-4162-ab06-28fdd9ab3eb4.png",
    public_thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9xYS1kYXNoLm9ubGFuZC5pby9maWxlcy9jNWM3MDVjMi0wZTBiLTQxNjItYWIwNi0yOGZkZDlhYjNlYjQucG5n?w=400&h=400",
    active: "not pivot",
    artwork: null,
    ar: null,
    shared: 0,
    owner: true,
    archived_at: null
  },
  {
    id: 1827,
    uuid: "2be8d763-11ac-4448-9ea2-245847b94671",
    title: "snap.png",
    description: null,
    type: "image",
    asset_type: "my-media",
    path: "metaverse/objects/production/snap-1728262319365.png",
    thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9xYS1kYXNoLm9ubGFuZC5pby9maWxlcy8yYmU4ZDc2My0xMWFjLTQ0NDgtOWVhMi0yNDU4NDdiOTQ2NzEucG5n?w=400&h=400",
    size: null,
    is_public: false,
    user_id: 12,
    is_360: true,
    url: "https://qa-dash.onland.io/files/2be8d763-11ac-4448-9ea2-245847b94671.png",
    public_thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9xYS1kYXNoLm9ubGFuZC5pby9maWxlcy8yYmU4ZDc2My0xMWFjLTQ0NDgtOWVhMi0yNDU4NDdiOTQ2NzEucG5n?w=400&h=400",
    active: "not pivot",
    artwork: null,
    ar: null,
    shared: 0,
    owner: true,
    archived_at: null
  },
  {
    id: 1780,
    uuid: "bb4719b0-3b19-4ea1-9b06-28046e9fdebe",
    title: "20-metaverse-fun-facts-you-had-no-idea-about-1920x1080.jpg",
    description: null,
    type: "image",
    asset_type: "my-media",
    path: "assets360/qa_onland/my-media/production/20-metaverse-fun-facts-you-had-no-idea-about-1920x1080-c456d8eb-b918-4599-804a-24e8eb537eaa.jpg",
    thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9xYS1kYXNoLm9ubGFuZC5pby9maWxlcy9iYjQ3MTliMC0zYjE5LTRlYTEtOWIwNi0yODA0NmU5ZmRlYmUuanBn?w=400&h=400",
    size: 1785263,
    is_public: false,
    user_id: 12,
    is_360: false,
    url: "https://qa-dash.onland.io/files/bb4719b0-3b19-4ea1-9b06-28046e9fdebe.jpg",
    public_thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9xYS1kYXNoLm9ubGFuZC5pby9maWxlcy9iYjQ3MTliMC0zYjE5LTRlYTEtOWIwNi0yODA0NmU5ZmRlYmUuanBn?w=400&h=400",
    active: "not pivot",
    artwork: null,
    ar: null,
    shared: 0,
    owner: true,
    archived_at: null
  },
  {
    id: 1468,
    uuid: "32c01883-770d-4030-8d88-f46aa8eed20a",
    title: "default-238db2dc-9893-4c18-894d-0413b5c220cf-artwork (1).glb",
    description: null,
    type: "model",
    asset_type: "my-media",
    path: "assets360/QA_EventFy/my-media/production/default-238db2dc-9893-4c18-894d-0413b5c220cf-artwork_(1)-2b5dd78f-ea5a-4f64-ba6d-32d3a19286bd.glb",
    thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9uZXh0cmVhbGl0eWRpZ2l0YWwuYmxvYi5jb3JlLndpbmRvd3MubmV0L25leHRyZWFsaXR5ZGlnaXRhbC9hc3NldHMzNjAvUUFfRXZlbnRGeS9teS1tZWRpYS9wcm9kdWN0aW9uL2RlZmF1bHQtMjM4ZGIyZGMtOTg5My00YzE4LTg5NGQtMDQxM2I1YzIyMGNmLWFydHdvcmtfKDEpLXRodW1iLTQyNmYwY2ZjLWJlNTgtNDQyYS1iMzE4LWE0N2U2ZjM2ZTY5Yy5wbmc=?w=400&h=400",
    size: null,
    is_public: false,
    user_id: 12,
    is_360: true,
    url: "https://qa-dash.onland.io/files/32c01883-770d-4030-8d88-f46aa8eed20a.glb",
    public_thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9uZXh0cmVhbGl0eWRpZ2l0YWwuYmxvYi5jb3JlLndpbmRvd3MubmV0L25leHRyZWFsaXR5ZGlnaXRhbC9hc3NldHMzNjAvUUFfRXZlbnRGeS9teS1tZWRpYS9wcm9kdWN0aW9uL2RlZmF1bHQtMjM4ZGIyZGMtOTg5My00YzE4LTg5NGQtMDQxM2I1YzIyMGNmLWFydHdvcmtfKDEpLXRodW1iLTQyNmYwY2ZjLWJlNTgtNDQyYS1iMzE4LWE0N2U2ZjM2ZTY5Yy5wbmc=?w=400&h=400",
    active: "not pivot",
    artwork: null,
    ar: null,
    shared: 0,
    owner: true,
    archived_at: null
  },
  {
    id: 1402,
    uuid: "da522bfc-6afc-4ea2-8716-69771a1184d9",
    title: "Mattis fusce primis sem placerat eget?",
    description: null,
    type: "image",
    asset_type: "my-media",
    path: "https://hubs-qa-verse-proxy.onland.workers.dev/files/674a5f39-4aa8-4846-a378-66dd1b1bbc66.jpg?token=18f392daf262fa81ee8ea53842b58c8a",
    thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9xYS1kYXNoLm9ubGFuZC5pby9maWxlcy9kYTUyMmJmYy02YWZjLTRlYTItODcxNi02OTc3MWExMTg0ZDkuanBnP3Rva2VuPTE4ZjM5MmRhZjI2MmZhODFlZThlYTUzODQyYjU4Yzhh?w=400&h=400",
    size: null,
    is_public: false,
    user_id: 1123,
    is_360: true,
    url: "https://qa-dash.onland.io/files/da522bfc-6afc-4ea2-8716-69771a1184d9.jpg?token=18f392daf262fa81ee8ea53842b58c8a",
    public_thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9xYS1kYXNoLm9ubGFuZC5pby9maWxlcy9kYTUyMmJmYy02YWZjLTRlYTItODcxNi02OTc3MWExMTg0ZDkuanBnP3Rva2VuPTE4ZjM5MmRhZjI2MmZhODFlZThlYTUzODQyYjU4Yzhh?w=400&h=400",
    active: "not pivot",
    artwork: {
      id: 361,
      created_at: "2024-09-03T19:10:04.000000Z",
      updated_at: "2024-09-03T19:10:04.000000Z",
      title: "Mattis fusce primis sem placerat eget?",
      artist: "me myself and i",
      date: null,
      description: null,
      medium: "Digital File",
      technique: null,
      dimensions: "100 x 210.65 in",
      artwork_model: null,
      dimensionsX: 210.65,
      dimensionsY: 100,
      dimensionsZ: 210.65,
      unit: "in",
      artist_statement: null
    },
    ar: null,
    shared: 1,
    owner: false,
    archived_at: null
  },
  {
    id: 1150,
    uuid: "7acfee60-2587-4e4c-a961-858a3e590917",
    title: "only artists - image",
    description: null,
    type: "image",
    asset_type: "my-media",
    path: "assets360/qa_onland/my-media/production/Screenshot_5.jpg",
    thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9xYS1kYXNoLm9ubGFuZC5pby9maWxlcy83YWNmZWU2MC0yNTg3LTRlNGMtYTk2MS04NThhM2U1OTA5MTcuanBn?w=400&h=400",
    size: 279087,
    is_public: false,
    user_id: 1123,
    is_360: false,
    url: "https://qa-dash.onland.io/files/7acfee60-2587-4e4c-a961-858a3e590917.jpg",
    public_thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9xYS1kYXNoLm9ubGFuZC5pby9maWxlcy83YWNmZWU2MC0yNTg3LTRlNGMtYTk2MS04NThhM2U1OTA5MTcuanBn?w=400&h=400",
    active: "not pivot",
    artwork: null,
    ar: null,
    shared: 1,
    owner: false,
    archived_at: null
  },
  {
    id: 1149,
    uuid: "eb7184be-69ec-41b7-859c-6bce06d5c584",
    title: "pdf to be shared with artists",
    description: null,
    type: "pdf",
    asset_type: "my-media",
    path: "assets360/qa_onland/my-media/production/NRDL-Onland_Metaverse_v1.40.0_-_Mar_04_18_44-040324-185157.pdf",
    thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9uZXh0cmVhbGl0eS1pbmR1c3RyaWVzLnMzLmFtYXpvbmF3cy5jb20vYXNzZXRzMzYwL3FhX29ubGFuZC9teS1tZWRpYS9wcm9kdWN0aW9uL05SREwtT25sYW5kX01ldGF2ZXJzZV92MS40MC4wXy1fTWFyXzA0XzE4XzQ0LTA0MDMyNC0xODUxNTcucGRm?w=400&h=400",
    size: 55534,
    is_public: false,
    user_id: 5169,
    is_360: false,
    url: "https://qa-dash.onland.io/files/eb7184be-69ec-41b7-859c-6bce06d5c584.pdf",
    public_thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9uZXh0cmVhbGl0eS1pbmR1c3RyaWVzLnMzLmFtYXpvbmF3cy5jb20vYXNzZXRzMzYwL3FhX29ubGFuZC9teS1tZWRpYS9wcm9kdWN0aW9uL05SREwtT25sYW5kX01ldGF2ZXJzZV92MS40MC4wXy1fTWFyXzA0XzE4XzQ0LTA0MDMyNC0xODUxNTcucGRm?w=400&h=400",
    active: "not pivot",
    artwork: null,
    ar: null,
    shared: 1,
    owner: false,
    archived_at: null
  },
  {
    id: 1148,
    uuid: "92947331-1c47-4a9d-a928-ed65f7382325",
    title: "Video to be shared with artist",
    description: null,
    type: "video",
    asset_type: "my-media",
    path: "assets360/qa_onland/my-media/production/cookies.mp4",
    thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9uZXh0cmVhbGl0eS1pbmR1c3RyaWVzLnMzLmFtYXpvbmF3cy5jb20vYXNzZXRzMzYwL3FhX29ubGFuZC9teS1tZWRpYS9wcm9kdWN0aW9uL2Nvb2tpZXMtdGh1bWIucG5n?w=400&h=400",
    size: 2471715,
    is_public: false,
    user_id: 5169,
    is_360: false,
    url: "https://qa-dash.onland.io/files/92947331-1c47-4a9d-a928-ed65f7382325.mp4",
    public_thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9uZXh0cmVhbGl0eS1pbmR1c3RyaWVzLnMzLmFtYXpvbmF3cy5jb20vYXNzZXRzMzYwL3FhX29ubGFuZC9teS1tZWRpYS9wcm9kdWN0aW9uL2Nvb2tpZXMtdGh1bWIucG5n?w=400&h=400",
    active: "not pivot",
    artwork: null,
    ar: null,
    shared: 1,
    owner: false,
    archived_at: null
  },
  {
    id: 1147,
    uuid: "1ae55157-43cf-4f5f-8ef8-58374176067d",
    title: "glb from user account",
    description: null,
    type: "model",
    asset_type: "my-media",
    path: "assets360/qa_onland/my-media/production/7c4f27ff-2b27-4f1b-9ea1-cb623398f834.glb",
    thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9uZXh0cmVhbGl0eS1pbmR1c3RyaWVzLnMzLmFtYXpvbmF3cy5jb20vYXNzZXRzMzYwL3FhX29ubGFuZC9teS1tZWRpYS9wcm9kdWN0aW9uLzdjNGYyN2ZmLTJiMjctNGYxYi05ZWExLWNiNjIzMzk4ZjgzNC10aHVtYi5wbmc=?w=400&h=400",
    size: 1288160,
    is_public: false,
    user_id: 5171,
    is_360: false,
    url: "https://qa-dash.onland.io/files/1ae55157-43cf-4f5f-8ef8-58374176067d.glb",
    public_thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9uZXh0cmVhbGl0eS1pbmR1c3RyaWVzLnMzLmFtYXpvbmF3cy5jb20vYXNzZXRzMzYwL3FhX29ubGFuZC9teS1tZWRpYS9wcm9kdWN0aW9uLzdjNGYyN2ZmLTJiMjctNGYxYi05ZWExLWNiNjIzMzk4ZjgzNC10aHVtYi5wbmc=?w=400&h=400",
    active: "not pivot",
    artwork: null,
    ar: null,
    shared: 1,
    owner: false,
    archived_at: null
  },
  {
    id: 1146,
    uuid: "8f1d02ad-9cc8-465a-8d4e-9621e0f13ee1",
    title: "gif shared with artist",
    description: null,
    type: "gif",
    asset_type: "my-media",
    path: "assets360/qa_onland/my-media/production/00d4657c-114b-4f6c-9c28-38c2cb765b39.gif",
    thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9uZXh0cmVhbGl0eS1pbmR1c3RyaWVzLnMzLmFtYXpvbmF3cy5jb20vYXNzZXRzMzYwL3FhX29ubGFuZC9teS1tZWRpYS9wcm9kdWN0aW9uLzAwZDQ2NTdjLTExNGItNGY2Yy05YzI4LTM4YzJjYjc2NWIzOS10aHVtYi5wbmc=?w=400&h=400",
    size: 7616491,
    is_public: false,
    user_id: 10,
    is_360: false,
    url: "https://qa-dash.onland.io/files/8f1d02ad-9cc8-465a-8d4e-9621e0f13ee1.gif",
    public_thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9uZXh0cmVhbGl0eS1pbmR1c3RyaWVzLnMzLmFtYXpvbmF3cy5jb20vYXNzZXRzMzYwL3FhX29ubGFuZC9teS1tZWRpYS9wcm9kdWN0aW9uLzAwZDQ2NTdjLTExNGItNGY2Yy05YzI4LTM4YzJjYjc2NWIzOS10aHVtYi5wbmc=?w=400&h=400",
    active: "not pivot",
    artwork: null,
    ar: null,
    shared: 1,
    owner: false,
    archived_at: null
  },
  {
    id: 1144,
    uuid: "48aa663a-8d9e-4cc4-9418-70ef41d21ec8",
    title: "title2",
    description: null,
    type: "image",
    asset_type: "my-media",
    path: "assets360/qa_onland/my-media/production/video.png",
    thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9xYS1kYXNoLm9ubGFuZC5pby9maWxlcy80OGFhNjYzYS04ZDllLTRjYzQtOTQxOC03MGVmNDFkMjFlYzgucG5n?w=400&h=400",
    size: 342,
    is_public: false,
    user_id: 4211,
    is_360: false,
    url: "https://qa-dash.onland.io/files/48aa663a-8d9e-4cc4-9418-70ef41d21ec8.png",
    public_thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9xYS1kYXNoLm9ubGFuZC5pby9maWxlcy80OGFhNjYzYS04ZDllLTRjYzQtOTQxOC03MGVmNDFkMjFlYzgucG5n?w=400&h=400",
    active: "not pivot",
    artwork: null,
    ar: null,
    shared: 1,
    owner: false,
    archived_at: null
  },
  {
    id: 1118,
    uuid: "59f9a517-63a5-4c76-89ab-d23870cc2236",
    title: "public artwork 2",
    description: null,
    type: "model",
    asset_type: "my-work",
    path: "assets360/qa_onland/my-media/production/loop-object-white.glb",
    thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9uZXh0cmVhbGl0eS1pbmR1c3RyaWVzLnMzLmFtYXpvbmF3cy5jb20vYXNzZXRzMzYwL3FhX29ubGFuZC9teS1tZWRpYS9wcm9kdWN0aW9uL2xvb3Atb2JqZWN0LXdoaXRlLXRodW1iLnBuZw==?w=400&h=400",
    size: 22909516,
    is_public: true,
    user_id: 5101,
    is_360: false,
    url: "https://qa-dash.onland.io/files/59f9a517-63a5-4c76-89ab-d23870cc2236.glb",
    public_thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9uZXh0cmVhbGl0eS1pbmR1c3RyaWVzLnMzLmFtYXpvbmF3cy5jb20vYXNzZXRzMzYwL3FhX29ubGFuZC9teS1tZWRpYS9wcm9kdWN0aW9uL2xvb3Atb2JqZWN0LXdoaXRlLXRodW1iLnBuZw==?w=400&h=400",
    active: "not pivot",
    artwork: {
      id: 268,
      created_at: "2024-08-01T01:22:41.000000Z",
      updated_at: "2024-08-01T01:23:10.000000Z",
      title: "public artwork 2",
      artist: "me",
      date: null,
      description: null,
      medium: null,
      technique: null,
      dimensions: null,
      artwork_model:
        "https://nextreality-industries.s3.amazonaws.com/assets360/qa_onland/my-media/production/loop-object-white-4c9c52b7-83a6-4a17-9cab-a1c26b16dca3-artwork.glb",
      dimensionsX: null,
      dimensionsY: null,
      dimensionsZ: null,
      unit: null,
      artist_statement: null
    },
    ar: {
      id: 276,
      asset360_id: 1118,
      ar_code: "QNA6OJlAA",
      qr_url: null
    },
    shared: 1,
    owner: false,
    archived_at: null
  },
  {
    id: 1114,
    uuid: "cd4f5253-c98f-4ca6-b88f-49ebfed58feb",
    title: "public asset",
    description: null,
    type: "image",
    asset_type: "my-media",
    path: "assets360/qa_onland/my-media/production/Screenshot_29.jpg",
    thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9xYS1kYXNoLm9ubGFuZC5pby9maWxlcy9jZDRmNTI1My1jOThmLTRjYTYtYjg4Zi00OWViZmVkNThmZWIuanBn?w=400&h=400",
    size: 124487,
    is_public: true,
    user_id: 5101,
    is_360: false,
    url: "https://qa-dash.onland.io/files/cd4f5253-c98f-4ca6-b88f-49ebfed58feb.jpg",
    public_thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9xYS1kYXNoLm9ubGFuZC5pby9maWxlcy9jZDRmNTI1My1jOThmLTRjYTYtYjg4Zi00OWViZmVkNThmZWIuanBn?w=400&h=400",
    active: "not pivot",
    artwork: null,
    ar: null,
    shared: 1,
    owner: false,
    archived_at: null
  },
  {
    id: 1111,
    uuid: "0cf9abe6-2935-47be-bfae-c671079ad34a",
    title: "new artwork",
    description: null,
    type: "image",
    asset_type: "my-work",
    path: "assets360/qa_onland/my-media/production/image__73__(1).png",
    thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9xYS1kYXNoLm9ubGFuZC5pby9maWxlcy8wY2Y5YWJlNi0yOTM1LTQ3YmUtYmZhZS1jNjcxMDc5YWQzNGEucG5n?w=400&h=400",
    size: 101016,
    is_public: false,
    user_id: 1123,
    is_360: false,
    url: "https://qa-dash.onland.io/files/0cf9abe6-2935-47be-bfae-c671079ad34a.png",
    public_thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9xYS1kYXNoLm9ubGFuZC5pby9maWxlcy8wY2Y5YWJlNi0yOTM1LTQ3YmUtYmZhZS1jNjcxMDc5YWQzNGEucG5n?w=400&h=400",
    active: "not pivot",
    artwork: {
      id: 263,
      created_at: "2024-08-01T00:48:54.000000Z",
      updated_at: "2024-08-01T00:49:00.000000Z",
      title: "new artwork",
      artist: "me",
      date: null,
      description: null,
      medium: null,
      technique: null,
      dimensions: null,
      artwork_model:
        "https://nextreality-industries.s3.amazonaws.com/assets360/qa_onland/my-media/production/image__73__(1)-a3348d66-afdc-4aaa-9886-a13125b99455-artwork.glb",
      dimensionsX: null,
      dimensionsY: null,
      dimensionsZ: null,
      unit: null,
      artist_statement: null
    },
    ar: {
      id: 271,
      asset360_id: 1111,
      ar_code: "UGz9Mnd_f",
      qr_url: "https://nextreality-industries.s3.amazonaws.com/Onland/room_qr_code/new-artwork-4.png"
    },
    shared: 1,
    owner: false,
    archived_at: null
  },
  {
    id: 1107,
    uuid: "215c9cba-9458-4655-8407-23527d95bc1b",
    title: "title",
    description: null,
    type: "image",
    asset_type: "my-media",
    path: "assets360/qa_onland/my-media/production/Screenshot_from_2024-07-31_13-14-23.png",
    thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9xYS1kYXNoLm9ubGFuZC5pby9maWxlcy8yMTVjOWNiYS05NDU4LTQ2NTUtODQwNy0yMzUyN2Q5NWJjMWIucG5n?w=400&h=400",
    size: 50096,
    is_public: true,
    user_id: 81,
    is_360: false,
    url: "https://qa-dash.onland.io/files/215c9cba-9458-4655-8407-23527d95bc1b.png",
    public_thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9xYS1kYXNoLm9ubGFuZC5pby9maWxlcy8yMTVjOWNiYS05NDU4LTQ2NTUtODQwNy0yMzUyN2Q5NWJjMWIucG5n?w=400&h=400",
    active: "not pivot",
    artwork: null,
    ar: null,
    shared: 1,
    owner: false,
    archived_at: null
  },
  {
    id: 1088,
    uuid: "e8f24059-485b-40d2-bfac-3a1793cc55df",
    title: "Title",
    description: null,
    type: "image",
    asset_type: "my-media",
    path: "assets360/Onland/my-media/production/pexels-thefatmansvision-3850526.jpg",
    thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9xYS1kYXNoLm9ubGFuZC5pby9maWxlcy9lOGYyNDA1OS00ODViLTQwZDItYmZhYy0zYTE3OTNjYzU1ZGYuanBn?w=400&h=400",
    size: 1309814,
    is_public: false,
    user_id: 12,
    is_360: false,
    url: "https://qa-dash.onland.io/files/e8f24059-485b-40d2-bfac-3a1793cc55df.jpg",
    public_thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9xYS1kYXNoLm9ubGFuZC5pby9maWxlcy9lOGYyNDA1OS00ODViLTQwZDItYmZhYy0zYTE3OTNjYzU1ZGYuanBn?w=400&h=400",
    active: "not pivot",
    artwork: null,
    ar: null,
    shared: 0,
    owner: true,
    archived_at: null
  },
  {
    id: 1001,
    uuid: "e7e6610b-50dd-4468-8792-62c5d089944c",
    title: "MainAfter-sharedwithartist",
    description: null,
    type: "image/jpeg",
    asset_type: "my-media",
    path: "https://hubs-qa-verse-cors-proxy.onland.workers.dev/https://letsenhance.io/static/8f5e523ee6b2479e26ecc91b9c25261e/1015f/MainAfter.jpg",
    thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9xYS1kYXNoLm9ubGFuZC5pby9maWxlcy9lN2U2NjEwYi01MGRkLTQ0NjgtODc5Mi02MmM1ZDA4OTk0NGMuanBn?w=400&h=400",
    size: null,
    is_public: false,
    user_id: 1123,
    is_360: true,
    url: "https://qa-dash.onland.io/files/e7e6610b-50dd-4468-8792-62c5d089944c.jpg",
    public_thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9xYS1kYXNoLm9ubGFuZC5pby9maWxlcy9lN2U2NjEwYi01MGRkLTQ0NjgtODc5Mi02MmM1ZDA4OTk0NGMuanBn?w=400&h=400",
    active: "not pivot",
    artwork: null,
    ar: null,
    shared: 1,
    owner: false,
    archived_at: null
  },
  {
    id: 958,
    uuid: "a82d7e4a-d9cb-4470-a1c7-9c97d386ddee",
    title: "duct-shared with artists",
    description: null,
    type: "model",
    asset_type: "my-media",
    path: "assets360//my-media/production/duct.glb",
    thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9uZXh0cmVhbGl0eS1pbmR1c3RyaWVzLnMzLmFtYXpvbmF3cy5jb20vYXNzZXRzMzYwLy9teS1tZWRpYS9wcm9kdWN0aW9uL2R1Y3QtdGh1bWIucG5n?w=400&h=400",
    size: 214092,
    is_public: false,
    user_id: 1123,
    is_360: false,
    url: "https://qa-dash.onland.io/files/a82d7e4a-d9cb-4470-a1c7-9c97d386ddee.glb",
    public_thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9uZXh0cmVhbGl0eS1pbmR1c3RyaWVzLnMzLmFtYXpvbmF3cy5jb20vYXNzZXRzMzYwLy9teS1tZWRpYS9wcm9kdWN0aW9uL2R1Y3QtdGh1bWIucG5n?w=400&h=400",
    active: "not pivot",
    artwork: null,
    ar: null,
    shared: 1,
    owner: false,
    archived_at: null
  },
  {
    id: 845,
    uuid: "b2aece24-4320-4a1a-838d-c59eab2f9a8d",
    title: "Icon",
    description: null,
    type: "image",
    asset_type: "my-media",
    path: "assets360/Onland/my-media/production/outlook_4096_black.png",
    thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9xYS1kYXNoLm9ubGFuZC5pby9maWxlcy9iMmFlY2UyNC00MzIwLTRhMWEtODM4ZC1jNTllYWIyZjlhOGQucG5n?w=400&h=400",
    size: 53907,
    is_public: false,
    user_id: 12,
    is_360: false,
    url: "https://qa-dash.onland.io/files/b2aece24-4320-4a1a-838d-c59eab2f9a8d.png",
    public_thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9xYS1kYXNoLm9ubGFuZC5pby9maWxlcy9iMmFlY2UyNC00MzIwLTRhMWEtODM4ZC1jNTllYWIyZjlhOGQucG5n?w=400&h=400",
    active: "not pivot",
    artwork: null,
    ar: null,
    shared: 0,
    owner: true,
    archived_at: null
  },
  {
    id: 844,
    uuid: "c63d086a-9c4a-4d98-92f3-7f40d1a810b5",
    title: "My media",
    description: null,
    type: "image",
    asset_type: "my-media",
    path: "assets360/Onland/my-media/production/pexels-adrien-olichon-2387793.jpg",
    thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9xYS1kYXNoLm9ubGFuZC5pby9maWxlcy9jNjNkMDg2YS05YzRhLTRkOTgtOTJmMy03ZjQwZDFhODEwYjUuanBn?w=400&h=400",
    size: 2109789,
    is_public: false,
    user_id: 12,
    is_360: false,
    url: "https://qa-dash.onland.io/files/c63d086a-9c4a-4d98-92f3-7f40d1a810b5.jpg",
    public_thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9xYS1kYXNoLm9ubGFuZC5pby9maWxlcy9jNjNkMDg2YS05YzRhLTRkOTgtOTJmMy03ZjQwZDFhODEwYjUuanBn?w=400&h=400",
    active: "not pivot",
    artwork: null,
    ar: null,
    shared: 0,
    owner: true,
    archived_at: null
  },
  {
    id: 818,
    uuid: "b057459c-226d-4d85-acd6-b8e05368b637",
    title: "Events Improvements",
    description: null,
    type: "image",
    asset_type: "my-media",
    path: "https://qa-onland-cors-proxy.go2land.link/https://qa-onland-assets.go2land.link/files/bc3a65ed-92f1-4e74-8465-d2901faa2b8f.jpg",
    thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9xYS1kYXNoLm9ubGFuZC5pby9maWxlcy9iMDU3NDU5Yy0yMjZkLTRkODUtYWNkNi1iOGUwNTM2OGI2MzcuanBn?w=400&h=400",
    size: 362495,
    is_public: false,
    user_id: 12,
    is_360: false,
    url: "https://qa-dash.onland.io/files/b057459c-226d-4d85-acd6-b8e05368b637.jpg",
    public_thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9xYS1kYXNoLm9ubGFuZC5pby9maWxlcy9iMDU3NDU5Yy0yMjZkLTRkODUtYWNkNi1iOGUwNTM2OGI2MzcuanBn?w=400&h=400",
    active: "not pivot",
    artwork: null,
    ar: null,
    shared: 0,
    owner: true,
    archived_at: null
  },
  {
    id: 680,
    uuid: "401d0688-63bb-4bff-a6b7-c08d4b59bbdc",
    title: "Code",
    description: null,
    type: "image",
    asset_type: "my-media",
    path: "assets360/QA_EventFy/my-media/production/Screenshot_2024-02-05_155105.png",
    thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9xYS1kYXNoLm9ubGFuZC5pby9maWxlcy80MDFkMDY4OC02M2JiLTRiZmYtYTZiNy1jMDhkNGI1OWJiZGMucG5n?w=400&h=400",
    size: 58160,
    is_public: false,
    user_id: 12,
    is_360: false,
    url: "https://qa-dash.onland.io/files/401d0688-63bb-4bff-a6b7-c08d4b59bbdc.png",
    public_thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9xYS1kYXNoLm9ubGFuZC5pby9maWxlcy80MDFkMDY4OC02M2JiLTRiZmYtYTZiNy1jMDhkNGI1OWJiZGMucG5n?w=400&h=400",
    active: "not pivot",
    artwork: null,
    ar: null,
    shared: 0,
    owner: true,
    archived_at: null
  },
  {
    id: 679,
    uuid: "09187fde-6b62-403e-a768-fd5a4c299fb3",
    title: "Dog",
    description: null,
    type: "image",
    asset_type: "my-media",
    path: "assets360/QA_EventFy/my-media/production/jajajaa.jpg",
    thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9xYS1kYXNoLm9ubGFuZC5pby9maWxlcy8wOTE4N2ZkZS02YjYyLTQwM2UtYTc2OC1mZDVhNGMyOTlmYjMuanBn?w=400&h=400",
    size: 59213,
    is_public: false,
    user_id: 12,
    is_360: false,
    url: "https://qa-dash.onland.io/files/09187fde-6b62-403e-a768-fd5a4c299fb3.jpg",
    public_thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9xYS1kYXNoLm9ubGFuZC5pby9maWxlcy8wOTE4N2ZkZS02YjYyLTQwM2UtYTc2OC1mZDVhNGMyOTlmYjMuanBn?w=400&h=400",
    active: "not pivot",
    artwork: null,
    ar: null,
    shared: 0,
    owner: true,
    archived_at: null
  },
  {
    id: 678,
    uuid: "2703d476-ef81-4d32-8f74-3a934f9daae1",
    title: "Big Image",
    description: null,
    type: "image",
    asset_type: "my-media",
    path: "assets360/QA_EventFy/my-media/production/tudor-baciu-vc3iVL_znJ8-unsplash.jpg",
    thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9xYS1kYXNoLm9ubGFuZC5pby9maWxlcy8yNzAzZDQ3Ni1lZjgxLTRkMzItOGY3NC0zYTkzNGY5ZGFhZTEuanBn?w=400&h=400",
    size: 4019084,
    is_public: false,
    user_id: 12,
    is_360: false,
    url: "https://qa-dash.onland.io/files/2703d476-ef81-4d32-8f74-3a934f9daae1.jpg",
    public_thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9xYS1kYXNoLm9ubGFuZC5pby9maWxlcy8yNzAzZDQ3Ni1lZjgxLTRkMzItOGY3NC0zYTkzNGY5ZGFhZTEuanBn?w=400&h=400",
    active: "not pivot",
    artwork: null,
    ar: null,
    shared: 0,
    owner: true,
    archived_at: null
  },
  {
    id: 677,
    uuid: "a9532581-83e2-4165-a946-d50353bd1c0e",
    title: "NRD Logo",
    description: null,
    type: "image",
    asset_type: "my-media",
    path: "assets360/QA_EventFy/my-media/production/Next_Reality_Digital_Web.png",
    thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9xYS1kYXNoLm9ubGFuZC5pby9maWxlcy9hOTUzMjU4MS04M2UyLTQxNjUtYTk0Ni1kNTAzNTNiZDFjMGUucG5n?w=400&h=400",
    size: 20432,
    is_public: false,
    user_id: 12,
    is_360: false,
    url: "https://qa-dash.onland.io/files/a9532581-83e2-4165-a946-d50353bd1c0e.png",
    public_thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9xYS1kYXNoLm9ubGFuZC5pby9maWxlcy9hOTUzMjU4MS04M2UyLTQxNjUtYTk0Ni1kNTAzNTNiZDFjMGUucG5n?w=400&h=400",
    active: "not pivot",
    artwork: null,
    ar: null,
    shared: 0,
    owner: true,
    archived_at: null
  },
  {
    id: 676,
    uuid: "6b049cf4-752d-4c9d-bb45-fc3e9aea5c93",
    title: "Robot",
    description: null,
    type: "image",
    asset_type: "my-media",
    path: "assets360/QA_EventFy/my-media/production/412badb777c14f9a8509c65b66bec4d4.jpg",
    thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9xYS1kYXNoLm9ubGFuZC5pby9maWxlcy82YjA0OWNmNC03NTJkLTRjOWQtYmI0NS1mYzNlOWFlYTVjOTMuanBn?w=400&h=400",
    size: 27930,
    is_public: false,
    user_id: 12,
    is_360: false,
    url: "https://qa-dash.onland.io/files/6b049cf4-752d-4c9d-bb45-fc3e9aea5c93.jpg",
    public_thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9xYS1kYXNoLm9ubGFuZC5pby9maWxlcy82YjA0OWNmNC03NTJkLTRjOWQtYmI0NS1mYzNlOWFlYTVjOTMuanBn?w=400&h=400",
    active: "not pivot",
    artwork: null,
    ar: null,
    shared: 0,
    owner: true,
    archived_at: null
  },
  {
    id: 675,
    uuid: "d0f1443d-2c05-489b-8a31-d983a3f72f45",
    title: "QR",
    description: null,
    type: "image",
    asset_type: "my-media",
    path: "assets360/QA_EventFy/my-media/production/Trivial-Striped-Vacation.png",
    thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9xYS1kYXNoLm9ubGFuZC5pby9maWxlcy9kMGYxNDQzZC0yYzA1LTQ4OWItOGEzMS1kOTgzYTNmNzJmNDUucG5n?w=400&h=400",
    size: 5658,
    is_public: false,
    user_id: 12,
    is_360: false,
    url: "https://qa-dash.onland.io/files/d0f1443d-2c05-489b-8a31-d983a3f72f45.png",
    public_thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9xYS1kYXNoLm9ubGFuZC5pby9maWxlcy9kMGYxNDQzZC0yYzA1LTQ4OWItOGEzMS1kOTgzYTNmNzJmNDUucG5n?w=400&h=400",
    active: "not pivot",
    artwork: null,
    ar: null,
    shared: 0,
    owner: true,
    archived_at: null
  },
  {
    id: 674,
    uuid: "1cc80592-aff9-4ab0-9c3e-011c706be2cc",
    title: "Onland Logo",
    description: null,
    type: "image",
    asset_type: "my-media",
    path: "assets360/QA_EventFy/my-media/production/3a4567f1-db59-48d8-a9ac-f781513d787e.png",
    thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9xYS1kYXNoLm9ubGFuZC5pby9maWxlcy8xY2M4MDU5Mi1hZmY5LTRhYjAtOWMzZS0wMTFjNzA2YmUyY2MucG5n?w=400&h=400",
    size: 1691,
    is_public: false,
    user_id: 12,
    is_360: false,
    url: "https://qa-dash.onland.io/files/1cc80592-aff9-4ab0-9c3e-011c706be2cc.png",
    public_thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9xYS1kYXNoLm9ubGFuZC5pby9maWxlcy8xY2M4MDU5Mi1hZmY5LTRhYjAtOWMzZS0wMTFjNzA2YmUyY2MucG5n?w=400&h=400",
    active: "not pivot",
    artwork: null,
    ar: null,
    shared: 0,
    owner: true,
    archived_at: null
  },
  {
    id: 673,
    uuid: "4ceffb3d-22f8-4b8f-831b-93c803890184",
    title: "Terms and Conditions",
    description: null,
    type: "pdf",
    asset_type: "my-media",
    path: "assets360/QA_EventFy/my-media/production/terrminos-y-condiciones-cta-Cte-amiga-31f05ee24ba759538c6adfb4202f3af1c4dd638e71ebb76350369ff8a6209533.pdf",
    thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9uZXh0cmVhbGl0eS1pbmR1c3RyaWVzLnMzLmFtYXpvbmF3cy5jb20vYXNzZXRzMzYwL1FBX0V2ZW50RnkvbXktbWVkaWEvcHJvZHVjdGlvbi90ZXJybWlub3MteS1jb25kaWNpb25lcy1jdGEtQ3RlLWFtaWdhLTMxZjA1ZWUyNGJhNzU5NTM4YzZhZGZiNDIwMmYzYWYxYzRkZDYzOGU3MWViYjc2MzUwMzY5ZmY4YTYyMDk1MzMucGRm?w=400&h=400",
    size: 96471,
    is_public: false,
    user_id: 12,
    is_360: false,
    url: "https://qa-dash.onland.io/files/4ceffb3d-22f8-4b8f-831b-93c803890184.pdf",
    public_thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9uZXh0cmVhbGl0eS1pbmR1c3RyaWVzLnMzLmFtYXpvbmF3cy5jb20vYXNzZXRzMzYwL1FBX0V2ZW50RnkvbXktbWVkaWEvcHJvZHVjdGlvbi90ZXJybWlub3MteS1jb25kaWNpb25lcy1jdGEtQ3RlLWFtaWdhLTMxZjA1ZWUyNGJhNzU5NTM4YzZhZGZiNDIwMmYzYWYxYzRkZDYzOGU3MWViYjc2MzUwMzY5ZmY4YTYyMDk1MzMucGRm?w=400&h=400",
    active: "not pivot",
    artwork: null,
    ar: null,
    shared: 0,
    owner: true,
    archived_at: null
  },
  {
    id: 670,
    uuid: "3c530de0-59b5-4803-b051-3cd9624e60e2",
    title: "Pixel Downloading GIF",
    description: "By Dominic Ewan",
    type: "gif",
    asset_type: "my-media",
    path: "assets360/QA_EventFy/my-media/production/giphy.gif",
    thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9uZXh0cmVhbGl0eS1pbmR1c3RyaWVzLnMzLmFtYXpvbmF3cy5jb20vYXNzZXRzMzYwL1FBX0V2ZW50RnkvbXktbWVkaWEvcHJvZHVjdGlvbi9naXBoeS10aHVtYi5wbmc=?w=400&h=400",
    size: 347937,
    is_public: false,
    user_id: 12,
    is_360: false,
    url: "https://qa-dash.onland.io/files/3c530de0-59b5-4803-b051-3cd9624e60e2.gif",
    public_thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9uZXh0cmVhbGl0eS1pbmR1c3RyaWVzLnMzLmFtYXpvbmF3cy5jb20vYXNzZXRzMzYwL1FBX0V2ZW50RnkvbXktbWVkaWEvcHJvZHVjdGlvbi9naXBoeS10aHVtYi5wbmc=?w=400&h=400",
    active: "not pivot",
    artwork: null,
    ar: null,
    shared: 0,
    owner: true,
    archived_at: null
  },
  {
    id: 661,
    uuid: "5b119033-5f0d-4c3c-b7ae-f426a2f57d72",
    title: "Data",
    description: "Additional data",
    type: "audio",
    asset_type: "my-media",
    path: "assets360/Onland/my-media/production/mixkit-doorbell-tone-2864.mp3",
    thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9uZXh0cmVhbGl0eS1pbmR1c3RyaWVzLnMzLmFtYXpvbmF3cy5jb20vYXNzZXRzMzYwL09ubGFuZC9teS1tZWRpYS9wcm9kdWN0aW9uL21peGtpdC1kb29yYmVsbC10b25lLTI4NjQubXAz?w=400&h=400",
    size: 125440,
    is_public: false,
    user_id: 12,
    is_360: false,
    url: "https://qa-dash.onland.io/files/5b119033-5f0d-4c3c-b7ae-f426a2f57d72.mp3",
    public_thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9uZXh0cmVhbGl0eS1pbmR1c3RyaWVzLnMzLmFtYXpvbmF3cy5jb20vYXNzZXRzMzYwL09ubGFuZC9teS1tZWRpYS9wcm9kdWN0aW9uL21peGtpdC1kb29yYmVsbC10b25lLTI4NjQubXAz?w=400&h=400",
    active: "not pivot",
    artwork: null,
    ar: null,
    shared: 0,
    owner: true,
    archived_at: null
  },
  {
    id: 657,
    uuid: "2019fed1-6695-404e-a3d7-10051e02930c",
    title: "Programming Quote",
    description: null,
    type: "image",
    asset_type: "my-media",
    path: "assets360/QA_Onland/my-media/production/tudor-baciu-vc3iVL_znJ8-unsplash.jpg",
    thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9xYS1kYXNoLm9ubGFuZC5pby9maWxlcy8yMDE5ZmVkMS02Njk1LTQwNGUtYTNkNy0xMDA1MWUwMjkzMGMuanBn?w=400&h=400",
    size: 4019084,
    is_public: false,
    user_id: 12,
    is_360: false,
    url: "https://qa-dash.onland.io/files/2019fed1-6695-404e-a3d7-10051e02930c.jpg",
    public_thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9xYS1kYXNoLm9ubGFuZC5pby9maWxlcy8yMDE5ZmVkMS02Njk1LTQwNGUtYTNkNy0xMDA1MWUwMjkzMGMuanBn?w=400&h=400",
    active: "not pivot",
    artwork: null,
    ar: null,
    shared: 0,
    owner: true,
    archived_at: null
  },
  {
    id: 656,
    uuid: "9513e793-4ff6-4984-a6a3-6eae1f5e7935",
    title: "Code",
    description: "Code",
    type: "image",
    asset_type: "my-media",
    path: "assets360/QA_Onland/my-media/production/Screenshot_2024-02-05_155105.png",
    thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9xYS1kYXNoLm9ubGFuZC5pby9maWxlcy85NTEzZTc5My00ZmY2LTQ5ODQtYTZhMy02ZWFlMWY1ZTc5MzUucG5n?w=400&h=400",
    size: 58160,
    is_public: false,
    user_id: 12,
    is_360: false,
    url: "https://qa-dash.onland.io/files/9513e793-4ff6-4984-a6a3-6eae1f5e7935.png",
    public_thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9xYS1kYXNoLm9ubGFuZC5pby9maWxlcy85NTEzZTc5My00ZmY2LTQ5ODQtYTZhMy02ZWFlMWY1ZTc5MzUucG5n?w=400&h=400",
    active: "not pivot",
    artwork: null,
    ar: null,
    shared: 0,
    owner: true,
    archived_at: null
  },
  {
    id: 232,
    uuid: "87235b71-b623-47ef-8016-a999fe3d3721",
    title: "Dta",
    description: null,
    type: "model",
    asset_type: "my-media",
    path: "assets360/Onland/my-media/production/aaaaa@test.com.glb",
    thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9uZXh0cmVhbGl0eS1pbmR1c3RyaWVzLnMzLmFtYXpvbmF3cy5jb20vYXNzZXRzMzYwL09ubGFuZC9teS1tZWRpYS9wcm9kdWN0aW9uL2FhYWFhQHRlc3QtdGh1bWIucG5n?w=400&h=400",
    size: 5810780,
    is_public: false,
    user_id: 12,
    is_360: false,
    url: "https://qa-dash.onland.io/files/87235b71-b623-47ef-8016-a999fe3d3721.glb",
    public_thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9uZXh0cmVhbGl0eS1pbmR1c3RyaWVzLnMzLmFtYXpvbmF3cy5jb20vYXNzZXRzMzYwL09ubGFuZC9teS1tZWRpYS9wcm9kdWN0aW9uL2FhYWFhQHRlc3QtdGh1bWIucG5n?w=400&h=400",
    active: "not pivot",
    artwork: null,
    ar: null,
    shared: 0,
    owner: true,
    archived_at: null
  },
  {
    id: 198,
    uuid: "7ed7b719-74ea-464c-8d61-01a218aeddf2",
    title: "Pdf test",
    description: "Pdf test",
    type: "pdf",
    asset_type: "my-media",
    path: "assets360/Onland/my-media/production/System_Context_Diagram_&_Container_Diagram_(1).pdf",
    thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9uZXh0cmVhbGl0eS1pbmR1c3RyaWVzLnMzLmFtYXpvbmF3cy5jb20vYXNzZXRzMzYwL09ubGFuZC9teS1tZWRpYS9wcm9kdWN0aW9uL1N5c3RlbV9Db250ZXh0X0RpYWdyYW1fJl9Db250YWluZXJfRGlhZ3JhbV8oMSkucGRm?w=400&h=400",
    size: 96671,
    is_public: false,
    user_id: 12,
    is_360: false,
    url: "https://qa-dash.onland.io/files/7ed7b719-74ea-464c-8d61-01a218aeddf2.pdf",
    public_thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9uZXh0cmVhbGl0eS1pbmR1c3RyaWVzLnMzLmFtYXpvbmF3cy5jb20vYXNzZXRzMzYwL09ubGFuZC9teS1tZWRpYS9wcm9kdWN0aW9uL1N5c3RlbV9Db250ZXh0X0RpYWdyYW1fJl9Db250YWluZXJfRGlhZ3JhbV8oMSkucGRm?w=400&h=400",
    active: "not pivot",
    artwork: null,
    ar: null,
    shared: 0,
    owner: true,
    archived_at: null
  },
  {
    id: 173,
    uuid: "98122833-bea6-475a-a82a-ce070f896bd6",
    title: "MUD Home",
    description: "MUD Home",
    type: "image",
    asset_type: "my-media",
    path: "assets360/Onland/my-media/production/media.png",
    thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9xYS1kYXNoLm9ubGFuZC5pby9maWxlcy85ODEyMjgzMy1iZWE2LTQ3NWEtYTgyYS1jZTA3MGY4OTZiZDYucG5n?w=400&h=400",
    size: 177645,
    is_public: false,
    user_id: 12,
    is_360: false,
    url: "https://qa-dash.onland.io/files/98122833-bea6-475a-a82a-ce070f896bd6.png",
    public_thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9xYS1kYXNoLm9ubGFuZC5pby9maWxlcy85ODEyMjgzMy1iZWE2LTQ3NWEtYTgyYS1jZTA3MGY4OTZiZDYucG5n?w=400&h=400",
    active: "not pivot",
    artwork: null,
    ar: null,
    shared: 0,
    owner: true,
    archived_at: null
  },
  {
    id: 146,
    uuid: "0c00cbd9-0368-4a85-a185-ccf5275302f5",
    title: "Audio Placeholder",
    description: null,
    type: "image",
    asset_type: "my-media",
    path: "assets360/Onland/my-media/production/audio-placeholder.png",
    thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9xYS1kYXNoLm9ubGFuZC5pby9maWxlcy8wYzAwY2JkOS0wMzY4LTRhODUtYTE4NS1jY2Y1Mjc1MzAyZjUucG5n?w=400&h=400",
    size: 76363,
    is_public: false,
    user_id: 12,
    is_360: false,
    url: "https://qa-dash.onland.io/files/0c00cbd9-0368-4a85-a185-ccf5275302f5.png",
    public_thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9xYS1kYXNoLm9ubGFuZC5pby9maWxlcy8wYzAwY2JkOS0wMzY4LTRhODUtYTE4NS1jY2Y1Mjc1MzAyZjUucG5n?w=400&h=400",
    active: "not pivot",
    artwork: null,
    ar: null,
    shared: 0,
    owner: true,
    archived_at: null
  },
  {
    id: 127,
    uuid: "22276cc7-481c-440e-aa22-f74e31a3961b",
    title: "Datos",
    description: "Datos",
    type: "image",
    asset_type: "my-media",
    path: "assets360/Onland/my-media/production/media.png",
    thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9xYS1kYXNoLm9ubGFuZC5pby9maWxlcy8yMjI3NmNjNy00ODFjLTQ0MGUtYWEyMi1mNzRlMzFhMzk2MWIucG5n?w=400&h=400",
    size: 177645,
    is_public: false,
    user_id: 12,
    is_360: false,
    url: "https://qa-dash.onland.io/files/22276cc7-481c-440e-aa22-f74e31a3961b.png",
    public_thumbnail:
      "https://thumbcraft.qa.onland.io/thumbnail/aHR0cHM6Ly9xYS1kYXNoLm9ubGFuZC5pby9maWxlcy8yMjI3NmNjNy00ODFjLTQ0MGUtYWEyMi1mNzRlMzFhMzk2MWIucG5n?w=400&h=400",
    active: "not pivot",
    artwork: null,
    ar: null,
    shared: 0,
    owner: true,
    archived_at: null
  }
];
